<div class="cosmos-section__container">
  <div
    *ngIf="loading"
    class="cosmos-section__container__spinner"
  >
    <cosmos-spinner></cosmos-spinner>
  </div>
  <div
    [ngClass]="{'cosmos-section__container__content': inheritHeight === false}"
    class="cosmos-section__container__content-adjusted">
    <ng-container *ngIf="sectionTitle">
      <div class="cosmos-section__container__content__wrapper">
        <div class="cosmos-section__container__content__title">
          {{ sectionTitle }}
        </div>
        <ng-content select="[addButton]"></ng-content>
      </div>
    </ng-container>
    <ng-content></ng-content>
  </div>
</div>
